import { render, staticRenderFns } from "./BookingFormSidebar.vue?vue&type=template&id=666e553a&scoped=true"
import script from "./BookingFormSidebar.vue?vue&type=script&lang=js"
export * from "./BookingFormSidebar.vue?vue&type=script&lang=js"
import style0 from "./BookingFormSidebar.vue?vue&type=style&index=0&id=666e553a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e553a",
  null
  
)

export default component.exports